import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardBody, Button, Table } from "reactstrap";
import { Play, Trash2, RefreshCw } from "react-feather";

const ManageJobsPage = () => {
  const [jobs, setJobs] = useState([]);

  const fetchJobs = async () => {
    const res = await axios.get("/jobs");
    setJobs(res.data);
  };

  const executeJob = async (id) => {
    await axios.post(`/jobs/${id}/execute`);
    fetchJobs();
  };

  const deleteJob = async (id) => {
    await axios.delete(`/jobs/${id}`);
    fetchJobs();
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <Card>
      <CardBody>
        <h4>Strategy Jobs</h4>

        <Button color="secondary" onClick={fetchJobs}>
          <RefreshCw size={16} /> Refresh
        </Button>

        <Table className="mt-3">
          <thead>
            <tr>
              <th>ID</th>
              <th>Strategy</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(job => (
              <tr key={job.id}>
                <td>{job.id}</td>
                <td>{job.strategy}</td>
                <td>{job.status}</td>
                <td>
                  <Button size="sm" color="success" onClick={() => executeJob(job.id)}>
                    <Play size={14} />
                  </Button>
                  {" "}
                  <Button size="sm" color="danger" onClick={() => deleteJob(job.id)}>
                    <Trash2 size={14} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default ManageJobsPage;
